import { render, staticRenderFns } from "./StarterSettings.vue?vue&type=template&id=58d49904&scoped=true&"
import script from "./StarterSettings.vue?vue&type=script&lang=js&"
export * from "./StarterSettings.vue?vue&type=script&lang=js&"
import style0 from "./StarterSettings.vue?vue&type=style&index=0&id=58d49904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d49904",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VListItem,VListItemContent,VRadio,VRadioGroup,VSwitch})
